import { parseInline } from './inlineParser.js';
import { parseTable } from './tableParser.js';
import { fullEscapeHTML } from './htmlUtil.js';
export function renderBlocks(blocks) {
    const parts = [];
    for (const block of blocks) {
        switch (block.type) {
            case 'paragraph':
                parts.push(renderParagraph(block.text));
                break;
            case 'heading':
                parts.push(renderHeading(block));
                break;
            case 'list':
                parts.push(renderList(block));
                break;
            case 'codeBlock':
                parts.push(renderCodeBlock(block.content));
                break;
            case 'table':
                parts.push(parseTable(block.raw));
                break;
        }
    }
    return parts.join('\n\n');
}
function renderParagraph(text) {
    // Parse the full multi-line text through inline parser.
    // The inline parser may consume \n (via italic fallback), merging lines.
    // After parsing, split by \n - each segment becomes its own <p>.
    const trimmed = text.trim();
    const parsed = parseInline(trimmed);
    const lines = parsed.split('\n');
    return lines
        .filter((line) => line.trim())
        .map((line) => `<p>${line.trim()}</p>`)
        .join('\n\n');
}
function renderHeading(block) {
    const level = block.level;
    const content = parseInline(block.text);
    return `<h${level}>${content}</h${level}>`;
}
function renderList(block) {
    const items = block.items.map((item) => {
        const contentHtml = parseInline(item.content);
        let inner = `<p>${contentHtml}</p>`;
        for (const cont of item.continuations) {
            inner += `\n<p>${parseInline(cont)}</p>`;
        }
        return `\t<li>${inner}</li>`;
    });
    return `\n\n<ul>\n${items.join('\n')}</ul>\n\n`;
}
function renderCodeBlock(content) {
    return `\n\n<pre class="code">${fullEscapeHTML(content)}\n</pre>\n\n`;
}
